export const SET_USER = 'SET_USER';
export const SET_WASTE_SLIP_REQUESTER = 'SET_WASTE_SLIP_REQUESTER';

